import { useState } from 'react';
import SelectorLeader from 'src/components/Admin/SelectorLeader';
import { isUrl } from 'src/helpers/validate';
import ShortLinkService from 'src/services/shortlink.service';
import notify from 'src/utils/notify';

const FormUpdateLink = ({ onSuccess = () => {} }) => {
    const [teams, setTeams] = useState([]);

    function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const link = formData.get('link');
        if (!isUrl(link)) {
            notify.warning('Please enter the correct link ');
            return;
        }
        if (!teams.length) {
            notify.warning('Please choose a team');
            return;
        }
        if (window.confirm(`Are you sure you haven't updated all the links of the ${teams.length} team`)) {
            ShortLinkService.updateLinks({
                link,
                teams,
            })
                .then((res) => {
                    notify.success();
                    onSuccess(res);
                })
                .catch(notify.response);
        }
    }
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div className="form-group mb-3">
                    <label htmlFor="">New Target Link</label>
                    <input type="text" className="form-control" name="link" />
                </div>
                <div className="form-group">
                    <div className="d-flex justify-content-between">
                        <label htmlFor="">Select Teams</label>
                        <div>Number of selected teams: {teams.length}</div>
                    </div>
                    <SelectorLeader onDataChange={setTeams} />
                </div>
                <div className="text-center">
                    <button className="btn btn-warning px-5" type="submit">
                        Update
                    </button>
                </div>
            </form>
        </div>
    );
};

export default FormUpdateLink;
